export const orderWorkflowGuide =
  'How orders work: (1) the orders list is driven with order_list_set_filters and order_list_paginate — ' +
  'read matching rows from context.order_list.items (each row has a pjas://order:<id> link); ' +
  '(2) open_link on a row opens that order; (3) goto_create_order opens the create wizard and does not save anything.';
